export default "__VITE_ASSET__9dfa9a56__"